import { cn } from "@repo/ui/lib/utils"
import * as React from "react"
import { useTranslations } from "use-intl"

interface DependencyCardProps {
  requirer: string
  required: string
  isViolated?: boolean
  isVibrating?: boolean
}

const DependencyCard = React.forwardRef<HTMLDivElement, DependencyCardProps>(
  ({ requirer, required, isViolated = false, isVibrating = false }, ref) => {
    const t = useTranslations("ui")
    return (
      <div
        ref={ref}
        className={cn(
          "p-4 rounded-lg",
          isViolated
            ? "bg-destructive-background border-destructive border"
            : "bg-white border border-gray-200",
        )}
        style={{
          animation: isVibrating
            ? "violationVibrate 0.6s ease-in-out"
            : undefined,
        }}
      >
        <div className="text-gray-900">
          {t.rich("proposalForm.dependencyRequires", {
            requirer,
            required,
            strong: (chunks) => <span className="font-semibold">{chunks}</span>,
          })}
        </div>
      </div>
    )
  },
)

DependencyCard.displayName = "DependencyCard"

export { DependencyCard, type DependencyCardProps }
